import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, from, of, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { PermissionService } from 'src/app/service/permission.service';
import { ConfigurationService } from '../../configurationService';
import { PROFILE, PROFILE_PERMISION } from '../constant/users-module-name';
import { AssociatedUser } from '../user/models/associated-user.model';
import { ObjectNames } from './../../../shared/constants';
import { ModulePermission } from './models/module-permission.model';
import { Profile } from './models/profile.model';
import { UserProfileService } from './services/profile.services';
import { AnyARecord } from 'dns';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  allrolePermissionCustom: any[];
  addEditProfileHeader = '';
  displayAddEditProfileModal = false;
  tempRole;
  isDisabledRoleEdit = false;
  configMenuProfileItems;
  tempProfile = {
    "id":0,
    "name":"",
    "description":"",
    "createdBy":"",
    "updatedDate":""
  }

  scrHeight:any;

  updatedRolePermissions : any[] = [];
  profileReportPermissionData: any[]=[];
  profileReportPermissionDataVM: any[]=[];
  selectedRole;
  index=0;

/* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();

  profile: Profile[] = [];
  cloneProfileList: Profile[] = [];
  profileAddEditForm: FormGroup;
  selectedProfileForEdit: any;
  displayAssociatedUsersModal: boolean = false;
  associatedUsers: AssociatedUser[] = [];
  readonly subModuleName: string = PROFILE;
  displayTransferProfileModal: boolean = false;
  profileDataForTransfer: any;
  filteredProfiles: Profile[] = [];
  profileTransferForm: FormGroup;
  profileIdForSelectedAssociatedUser: number;

  permissionTabIndex: number = 0;
  allModuleViewPermissions: boolean = true;
  allModuleCreatePermissions: boolean = true;
  allModuleEditPermissions: boolean = true;
  allModuleDeletePermissions: boolean = true;
  allModuleExportPermissions: boolean = true;
  selectedProfile: any;

  displayPermission = false;
  modulePermissions: any[] = [];
  modulePermissionsVM: any[] = [];
  reportPermission: any[] = [];
  modulePermissionData : ModulePermission[] = [];
  reportPermissionData: ModulePermission[] = [];
  isShowClonedPermissionDiv: boolean = true;

  constructor(
    private permissionService: PermissionService,
    private appMainService: AppMainService,
    private service: ConfigurationService,
    private messageService: MessageService,
    public app: AppMainComponent,
    private formBuilder: FormBuilder,
    private userProfileService: UserProfileService,
    private confirmationService: ConfirmationService,
  ) {
    this.prepareProfileAddEditForm();
    this.prepareTransferProfileForm();
    this.getScreenSize();
  }

  getScreenSize(event?) {
    if(window.innerHeight <= 900){
      this.scrHeight = window.innerHeight - 340 + "px";
    }
  }

  ngOnInit(): void {
    const userPermissions = this.permissionService.getPemrissionData();
    const roleUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ROLE);
    this.allrolePermissionCustom = roleUerPermission.permissions;
    this.configMenuProfileItems = [
      {
        label: "Profile",
        icon: 'pi pi-plus',
        command: () => {
          this.showAddRole();
        }
      },
    ];
    // this.prepareProfileAddEditForm();
    // this.prepareTransferProfileForm();
    this.getProfileList();
  }

  prepareProfileAddEditForm(): void {
    this.profileAddEditForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: [''],
      cloneProfile: [null]
    });
  }

  prepareTransferProfileForm(): void {
    this.profileTransferForm = this.formBuilder.group({
      newProfile: ['', Validators.required]
    });
  }

  getProfileList(): void {
    this.appMainService.isShowSpinner('getProfileList');
    this.userProfileService.getAllProfile()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.profile = response;
                  this.cloneProfileList = response;
                  this.appMainService.isHideSpinner('getProfileList');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('getProfileList');
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error?.error?.Message ? error?.error?.Message : 'Profile lists are not loaded, please try again later..'
                    });
                }),
                complete: (() => {
                })
            });
  }

  showAddRole(): void{
    this.addEditProfileHeader = 'Add Profile';
    this.isShowClonedPermissionDiv = true;
    this.displayAddEditProfileModal = true;
    this.selectedProfileForEdit = null;
  }

  showEditProfile(data) {
    this.addEditProfileHeader = 'Edit Profile';
    this.isShowClonedPermissionDiv = false;
    this.displayAddEditProfileModal = true;
    this.selectedProfileForEdit = data;
    this.setEditProfileForm(data);
  }

  cancelAddEditProfileModal(): void {
    this.profileAddEditForm.reset();
    this.displayAddEditProfileModal = false;
  }

  saveProfile(): void {
    if (this.profileAddEditForm.valid){
      if (this.selectedProfileForEdit == null){
        this.addNewProfile();
      }
      else {
        this.updateProfile();
      }
    }
  }

  addNewProfile(): void {
    const profileData = {
      name: this.profileAddEditForm.value['name'],
      description: this.profileAddEditForm.value['description'],
      cloneProfileId: this.profileAddEditForm.value['cloneProfile'] ? this.profileAddEditForm.value['cloneProfile'].id : null
    }
    this.appMainService.isShowSpinner('addNewProfile');
    this.userProfileService.saveProfile(profileData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getProfileList();
                this.profileAddEditForm.reset();
                this.displayAddEditProfileModal = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Profile added successfully...` });
                this.appMainService.isHideSpinner('addNewProfile');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('addNewProfile');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  updateProfile(): void {
    const profileData = {
      id: this.selectedProfileForEdit?.id,
      name: this.profileAddEditForm.value['name'],
      description: this.profileAddEditForm.value['description'],
      cloneProfileId: this.profileAddEditForm.value['cloneProfile'] ? this.profileAddEditForm.value['cloneProfile'].id : null
    }
    this.appMainService.isShowSpinner('updateProfile');
    this.userProfileService.updateProfile(profileData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getProfileList();
                this.profileAddEditForm.reset();
                this.displayAddEditProfileModal = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Profile updated successfully...` });
                this.appMainService.isHideSpinner('updateProfile');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('updateProfile');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  setEditProfileForm(editData): void {
    this.profileAddEditForm = this.formBuilder.group({
      name: [editData?.name, Validators.required],
      description: [editData?.description],
      cloneProfile: ['']
    })
  }

  copyProfile(data): void {
    this.addEditProfileHeader = 'Copy Profile';
    this.isShowClonedPermissionDiv = true;
    const selectedProfile = this.cloneProfileList.find((obj) => obj?.id == data?.id);

    this.displayAddEditProfileModal = true;
    this.selectedProfileForEdit = null;
    this.setCopyProfileForm(data, selectedProfile);
  }

  setCopyProfileForm(editData, selectedProfile): void {
    this.profileAddEditForm = this.formBuilder.group({
      name: [editData?.name, Validators.required],
      description: [editData?.description],
      cloneProfile: [selectedProfile]
    })
  }

  deleteProfileConfirmation(data): void {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Profile?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {

        this.filteredProfiles = [];
        this.profileDataForTransfer = data;

        if (data?.noOfAssociatedUsers > 0){
          this.displayTransferProfileModal = true;
          this.filteredProfiles = this.profile.filter(obj => obj?.id != data?.id);
        }
        else {
          this.transferAndDeleteProfile(true);
        }
      },
      reject: () => {
      }
    });
  }

  transferAndDeleteProfile(directDeleteWitoutTransfer = false){
      const profileData = {
        idForDelete: this.profileDataForTransfer?.id,
        idForTransfer: directDeleteWitoutTransfer ? 0 : this.profileTransferForm.value['newProfile']?.id
      }
      this.appMainService.isShowSpinner('transferAndDeleteProfile');
      this.userProfileService.deleteAndTransferProfile(profileData?.idForDelete , profileData?.idForTransfer)
      .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.displayTransferProfileModal = false;
                  this.profileDataForTransfer = null;
                  this.getProfileList();
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Transfer and deleted successfully...' });
                  this.appMainService.isHideSpinner('transferAndDeleteProfile');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('transferAndDeleteProfile');
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error?.error?.Message ? error?.error?.Message : 'Error occurred while transfer and delete role...'
                    });
                }),
                complete: (() => {
                })
          });
  }

  deleteProfile(profileId: number): void {
    this.appMainService.isShowSpinner('deleteRole');
    // this.roleHierarchyService.deleteRole(roleHierarchyId)
    // .pipe(takeUntil(this.ngUnsubscribe))
    //         .subscribe({
    //             next: (response) => {
    //               this.getRoleHierarchyList();
    //               this.appMainService.isHideSpinner('deleteRole');
    //             },
    //             error: ((error) => {
    //                 this.appMainService.isHideSpinner('deleteRole');
    //                 this.messageService.add({
    //                   severity: 'error',
    //                   summary: 'Error',
    //                   detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
    //                 });
    //             }),
    //             complete: (() => {
    //             })
    //       });
  }

  getNoOfAssociatedUsers(profileId: number, isAddedNewUser = false): void {
    this.profileIdForSelectedAssociatedUser = profileId;
    this.appMainService.isShowSpinner('getNoOfAssociatedUsers');
    this.userProfileService.getAssociatedUsers(this.profileIdForSelectedAssociatedUser)
    .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.associatedUsers = response;
                  this.displayAssociatedUsersModal = true;
                  if (isAddedNewUser){
                    this.getProfileList();
                  }
                  this.appMainService.isHideSpinner('getNoOfAssociatedUsers');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('getNoOfAssociatedUsers');
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error?.error?.Message ? error?.error?.Message : 'User lists are not loaded, please try again later..'
                    });
                }),
                complete: (() => {
                })
          });
  }

  closeAssociatedUserModalOutputEvent(): void {
    this.displayAssociatedUsersModal = false;
    this.associatedUsers = [];
  }

  completedAddNewUser(): void {
    this.getNoOfAssociatedUsers(this.profileIdForSelectedAssociatedUser, true);
  }

  closeTransferProfileModal(): void {
    this.displayTransferProfileModal = false;
  }

  getRoleCustomPermission(typeofpermission) {
    let permissionDetails = this.allrolePermissionCustom ? (this.allrolePermissionCustom.find(obj => obj.permissionName == typeofpermission && obj.statusId == 1) ? true : false) : false;
    return permissionDetails;
  }

  setProfilePermissions(profile) {
    this.displayPermission = true;
    this.selectedProfile = profile;
    this.selectedRole = profile;
    this.appMainService.isShowSpinner('loadRolePermission');
    this.userProfileService.getProfilesModulePermission(profile.id).subscribe(
      resp => {
        const convertedData = this.convertModulePermissionToTreeNodeDataModel(resp);
        // this.modulePermissions = convertedData;
        const allModulePermissions = convertedData.filter((treeData)=>{
          return treeData?.data?.hasChildren == true
        });
        this.modulePermissions = allModulePermissions.filter(p=> (p.children?.length>0));
        this.modulePermissionsVM = JSON.parse(JSON.stringify(allModulePermissions));
        // this.setPermission();    //check this fuction
        // this.checkAllData(this.modulePermissions);
        this.checkChildData();
        this.appMainService.isHideSpinner('loadRolePermission');
      },
      (error) => {
        this.appMainService.isHideSpinner('loadRolePermission');
      }
    );
    this.getReportPermission(profile);
  }

  checkChildData(){
    this.modulePermissions.forEach((item)=>{
        // console.log(item);
        let viewCount:{uncheckedCount:number,checkedCount:number} = this.countNoOFPermission(item?.children,'view');
        let deleteCount:{uncheckedCount:number,checkedCount:number} = this.countNoOFPermission(item?.children,'delete');
        let createCount:{uncheckedCount:number,checkedCount:number} = this.countNoOFPermission(item?.children,'create');
        let editCount:{uncheckedCount:number,checkedCount:number} = this.countNoOFPermission(item?.children,'edit');
        let exportCount:{uncheckedCount:number,checkedCount:number} = this.countNoOFPermission(item?.children,'export');
      //  console.log(viewCount,deleteCount,createCount,editCount,exportCount);
       this.setParentData(item,viewCount,'view');
       this.setParentData(item,deleteCount,'delete');
       this.setParentData(item,viewCount,'create');
       this.setParentData(item,editCount,'edit');
       this.setParentData(item,exportCount,'export');
    })
  }

  setParentData(item:any,count:{uncheckedCount:number,checkedCount:number},type){
      if(count?.checkedCount == item?.children?.length){
      if (type == 'view'){
        item.data.isView = true;
      }else if(type == 'edit'){
        item.data.isEdit = true;
      }else if(type == 'delete'){
        item.data.isDelete = true;
      }else if(type == 'export'){
        item.data.isExport = true;
      }else if(type == 'create'){
        item.data.isCreate = true;
      }
    }
  }

  convertModulePermissionToTreeNodeDataModel(reports) {
    return reports.map((report) => {
        const children =
            report.child && report.child.length > 0
                ? this.convertModulePermissionToTreeNodeDataModel(report.child)
                : [];
        let permissions;
        if ("permissions" in report){
           permissions = report?.permissions.reduce(
            (result, permission) => {
                if (permission.permissionName === "Export") {
                    result.isExport = permission.isEnabled || false;
                    result.exportPermissionId = permission.permissionId || 0;
                } else if (permission.permissionName === "Read") {
                    result.isView = permission.isEnabled || false;
                    result.viewPermissionId = permission.permissionId || 0;
                } else if (permission.permissionName === "Write") {
                    result.isCreate = permission.isEnabled || false;
                    result.createPermissionId = permission.permissionId || 0;
                } else if (permission.permissionName === "Edit") {
                    result.isEdit = permission.isEnabled || false;
                    result.editPermissionId = permission.permissionId || 0;
                } else if (permission.permissionName === "Delete") {
                    result.isDelete = permission.isEnabled || false;
                    result.deletePermissionId = permission.permissionId || 0;
                }
                return result;
            },
            {}
        );
        }
        return {
          data: {
              objectId: report?.objectId,
              hasChildren: children.length > 0 ? true : false,
              isExport: permissions?.isExport || false,
              isView: permissions?.isView || false,
              isCreate: permissions?.isCreate || false,
              isEdit: permissions?.isEdit || false,
              isDelete: permissions?.isDelete || false,
              exportPermissionId: permissions?.exportPermissionId,
              viewPermissionId: permissions?.viewPermissionId,
              createPermissionId: permissions?.createPermissionId,
              editPermissionId: permissions?.editPermissionId,
              deletePermissionId: permissions?.deletePermissionId,
              name: report?.displayName,
              isParent: report?.profileId ? false : true
          },
          children,
      };
    });
  }

  setAllModulePermissions(permissionIndex): void {
    let newPermission;
    switch (permissionIndex) {
      case 0: newPermission = this.allModuleViewPermissions; break;
      case 1: newPermission = this.allModuleCreatePermissions; break;
      case 2: newPermission = this.allModuleEditPermissions; break;
      case 3: newPermission = this.allModuleDeletePermissions; break;
      case 4: newPermission = this.allModuleExportPermissions; break;


    }
    this.modulePermissions.map(permissionObj => {
      if (permissionObj.permissions[permissionIndex].isEnabled != newPermission) {
        permissionObj.permissions[permissionIndex].isEnabled = newPermission;
        this.modulePermissionChanged(permissionObj.permissions[permissionIndex], permissionObj.objectId)
      }
    })
  }

  modulePermissionChanged(obj, objectId) {
    const newPermissionObj : ModulePermission = {
      profileID: this.selectedProfile.id,
      isEnabled: obj?.isEnabled,
      permissionId: obj?.permissionId,
      objectId: objectId
    }
    const existingPermissionIndex = this.modulePermissionData.findIndex(permissionObj => permissionObj.objectId == objectId && permissionObj.permissionId == obj.permissionId)

    if (existingPermissionIndex >= 0) {
      this.modulePermissionData.splice(existingPermissionIndex, 1)
    } else {
      this.modulePermissionData.push(newPermissionObj);
    }
    this.syncHeaderCheckbox(obj.permissionId);
  }

  syncHeaderCheckbox(permissionId) {
    const allPermissionCount = this.modulePermissions.length;
    const activePermissionCounts = this.modulePermissionData.filter(obj => obj.permissionId == permissionId && obj.isEnabled == true);
    const inactivePermissionCounts = this.modulePermissionData.filter(obj => obj.permissionId == permissionId && obj.isEnabled == false);
    let newStatus = (activePermissionCounts.length == allPermissionCount && inactivePermissionCounts.length == 0) ? true : false;

    // this condition is to handle initial state where all selected or unselected earlier
    if (activePermissionCounts.length == 0 && inactivePermissionCounts.length == 0) {
      const initialActivePermissions = this.modulePermissions.filter(obj => obj.permissions[permissionId - 1].statusId == 1)
      if (initialActivePermissions.length == allPermissionCount) {
        newStatus = true;
      } else {
        newStatus = false;
      }
    }

    switch (permissionId) {
      case 1: this.allModuleViewPermissions = newStatus; break;
      case 2: this.allModuleCreatePermissions = newStatus; break;
      case 3: this.allModuleEditPermissions = newStatus; break;
      case 4: this.allModuleDeletePermissions = newStatus; break;
      case 5: this.allModuleExportPermissions = newStatus; break;
    }
  }

  assignModulePermission() {
    const result = this.findChangesInModulePermission(this.modulePermissionsVM, this.modulePermissions);
    //console.log(result);
    if (result.length > 0) {
      this.appMainService.isShowSpinner('assignModulePermission');
      this.userProfileService.addProfilePermission(result).subscribe(
        resp => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Profile module permission updated Successfully...' });
          this.displayPermission = false;
          this.reportPermissionData = [];
          this.appMainService.isHideSpinner('assignModulePermission');
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while updating permissions...' })
          this.appMainService.isHideSpinner('assignModulePermission');
        },
        () => this.appMainService.isHideSpinner('assignModulePermission')
      );
    }
  }

  findChangesInModulePermission(originalObj, modifiedObj){
    const result = [];
    for (const modObj of modifiedObj){
      const origObj = originalObj.find((obj) => obj.data.name === modObj.data.name);
      if (!origObj) continue;

      if (modObj.data.isExport !== origObj.data.isExport){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isExport,
          permissionId: modObj.data.exportPermissionId
        });
      }

      if (modObj.data.isView !== origObj.data.isView){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isView,
          permissionId: modObj.data.viewPermissionId
        });
      }

      if (modObj.data.isEdit !== origObj.data.isEdit){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isEdit,
          permissionId: modObj.data.editPermissionId
        });
      }

      if (modObj.data.isDelete !== origObj.data.isDelete){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isDelete,
          permissionId: modObj.data.deletePermissionId
        });
      }

      if (modObj.data.isCreate !== origObj.data.isCreate){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isCreate,
          permissionId: modObj.data.createPermissionId
        });
      }

      if (modObj.children && modObj.children.length > 0){
        const childResults = this.findChangesInModulePermission(origObj.children, modObj.children);
        result.push(...childResults);
      }
    }
    return result;
  }

  getReportPermission(profile: any) {
    this.profileReportPermissionData = this.profileReportPermissionDataVM = [];
    this.appMainService.isShowSpinner('assignUserPermission');
    this.userProfileService.getReportsPermission(profile.id).subscribe(
      resp => {
          const reportData = resp;
          const convertedData = this.convertReportPermissionToTreeNodeDataModel(reportData);
          this.profileReportPermissionData = convertedData;
          this.profileReportPermissionDataVM = JSON.parse(JSON.stringify(convertedData));
          //console.log(this.profileReportPermissionDataVM);
      },
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message })
      },
      () => this.appMainService.isHideSpinner('assignUserPermission')
    );
  }

  convertReportPermissionToTreeNodeDataModel(reports) {
    return reports.map((report) => {
        const children =
            report.childReports && report.childReports.length > 0
                ? this.convertReportPermissionToTreeNodeDataModel(report.childReports)
                : [];
        const permissions = report.permissions.reduce(
            (result, permission) => {
                if (permission.permissionName === "Export") {
                    result.isExport = permission.isEnabled;
                    result.exportPermissionId = permission.permissionId;
                } else if (permission.permissionName === "Read") {
                    result.isView = permission.isEnabled;
                    result.viewPermissionId = permission.permissionId;
                }
                return result;
            },
            {}
        );
        return {
            data: {
                objectId: report.objectId,
                isChildren: children.length > 0 ? true : false,
                isExport: permissions.isExport || false,
                isView: permissions.isView || false,
                exportPermissionId: permissions.exportPermissionId,
                viewPermissionId: permissions.viewPermissionId,
                name: report.objectName,
                parentObjectId: report.parentObjectId
            },
            children,
        };
    });
  }

  // isdeleteAll:boolean = false;
  checkAllData(eventData, permissionType){
    if(eventData?.isParent){
      // debugger;
    let childern:any ;
    childern =  this.modulePermissions.find((data=>{
             if(data?.data?.name == eventData?.name){
                return data?.children
             }
      }))
      // console.log('childern',childern);
      this.allCheckPermission(childern?.children,permissionType,eventData);
    }else{
      this.modulePermissions?.forEach((item)=>{
        let count:{uncheckedCount:number,checkedCount:number};
        if(item?.data?.name == PROFILE_PERMISION?.CRM){
          // console.log('data?.data',item?.data);
           count =  this.countNoOFPermission(item?.children,permissionType);
        }
        if(item?.data?.name == PROFILE_PERMISION?.CompanyAndLocation){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

        if(item?.data?.name == PROFILE_PERMISION?.Configuration){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

      if(item?.data?.name == PROFILE_PERMISION?.FSM){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

      if(item?.data?.name == PROFILE_PERMISION?.Finance){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

      if(item?.data?.name == PROFILE_PERMISION?.Inventory){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

      if(item?.data?.name == PROFILE_PERMISION?.Miscellaneous){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

      if(item?.data?.name == PROFILE_PERMISION?.Others){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }

      if(item?.data?.name == PROFILE_PERMISION?.User){
          count =  this.countNoOFPermission(item?.children,permissionType);
      }
      this.setParentCheckBox(item,count,permissionType);
    });

    }
    // console.log(this.modulePermissions);
  }


setPermission(){
  this.modulePermissions?.forEach((item)=>{
    let count:{uncheckedCount:number,checkedCount:number};
    if(item?.data?.name == PROFILE_PERMISION?.CRM){
       count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.CRM);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.CRM)
    }else if(item?.data?.name == PROFILE_PERMISION?.CompanyAndLocation){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.CompanyAndLocation);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.CompanyAndLocation)
  }

    else if(item?.data?.name == PROFILE_PERMISION?.Configuration){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.Configuration);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.Configuration)
  }

  else if(item?.data?.name == PROFILE_PERMISION?.FSM){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.FSM);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.FSM)
  }

  else if(item?.data?.name == PROFILE_PERMISION?.Finance){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.Finance);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.Finance)
  }

  else if(item?.data?.name == PROFILE_PERMISION?.Inventory){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.Inventory);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.Inventory)
  }

  else if(item?.data?.name == PROFILE_PERMISION?.Miscellaneous){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.Miscellaneous);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.Miscellaneous)
  }

  else if(item?.data?.name == PROFILE_PERMISION?.Others){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.Others);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.Others)
  }

  else if(item?.data?.name == PROFILE_PERMISION?.User){
      count =  this.countNoOFPermission(item?.children,PROFILE_PERMISION?.User);
       this.setParentCheckBox(item,count,PROFILE_PERMISION?.User)
  }
 });
}

  setParentCheckBox(item:any,count:{uncheckedCount:number,checkedCount:number},type){
    if(count?.uncheckedCount > 0){
      if (type == 'view'){
        item.data.isView = false;
      }else if(type == 'edit'){
        item.data.isEdit = false;
      }else if(type == 'delete'){
        item.data.isDelete = false;
      }else if(type == 'export'){
        item.data.isExport = false;
      }else if(type == 'create'){
        item.data.isCreate = false;
      }
    }

    if(count?.checkedCount == item?.children?.length){
      if (type == 'view'){
        item.data.isView = true;
      }else if(type == 'edit'){
        item.data.isEdit = true;
      }else if(type == 'delete'){
        item.data.isDelete = true;
      }else if(type == 'export'){
        item.data.isExport = true;
      }else if(type == 'create'){
        item.data.isCreate = true;
      }
    }
  }

  countNoOFPermission(children: any[], type): {uncheckedCount:number,checkedCount:number} {
    let uncheckedCount:number  = 0;
    let checkedCount:number  = 0;
    for  (const child of children){
      if (type == 'view'){
        if (child.data.isView === false){
          uncheckedCount++;
        }else{
          checkedCount++;
        }
      }else if(type == 'edit'){
        if (child.data.isEdit === false){
          uncheckedCount++;
        }else{
          checkedCount++;
        }
      }else if(type == 'delete'){
        if (child.data.isDelete === false){
          uncheckedCount++;
        }else{
          checkedCount++;
        }
      }else if(type == 'export'){
        if (child.data.isExport === false){
          uncheckedCount++;
        }else{
          checkedCount++;
        }
      }else if(type == 'create'){
        if (child.data.isCreate === false){
          uncheckedCount++;
        }else{
          checkedCount++;
        }
      }

    }
    return {uncheckedCount:uncheckedCount,checkedCount:checkedCount};
  }

  // countNoOFPermission1(children: any[], type): number {
  //   let count  = 0;
  //   for  (const child of children){
  //     console.log("inside patrent",child);
  //     if (type == 'view'){
  //       if (child.data.isView === false){
  //         count++;
  //       }
  //     }else if(type == 'edit'){
  //       if (child.data.isEdit === false){
  //         count++;
  //       }
  //     }else if(type == 'delete'){
  //       if (child.data.isDelete === false){
  //         count++;
  //       }
  //     }else if(type == 'export'){
  //       if (child.data.isExport === false){
  //         count++;
  //       }
  //     }else if(type == 'create'){
  //       if (child.data.isCreate === false){
  //         count++;
  //       }
  //     }

  //   }
  //   return count;
  // }

  allCheckPermission(children: any[],permissionType,eventData) {
    // console.log('eventData',eventData);
    for  (const child of children){
      if (permissionType == 'view'){
        if (eventData?.isView){
          child.data.isView = true;
        }else{
          child.data.isView = false;
        }
      }else if(permissionType == 'edit'){
        if (eventData?.isEdit){
          child.data.isEdit = true;
        }else{
          child.data.isEdit = false;
        }
      }else if(permissionType == 'delete'){
        if (eventData?.isDelete){
          child.data.isDelete = true;
        }else{
          child.data.isDelete = false;
        }
      }else if(permissionType == 'export'){
        if (eventData?.isExport){
          child.data.isExport = true;
        }else{
          child.data.isExport = false;
        }
      }else if(permissionType == 'create'){
        if (eventData?.isCreate){
          child.data.isCreate = true;
        }else{
          child.data.isCreate = false;
        }
      }
    }
  }

  checkUncheckReport(eventData, permissionType, loopBreakCheck = false): void {
    if (eventData.parentObjectId > 0){
      this.profileReportPermissionData.forEach((obj) => {
        if (obj.data.objectId == eventData.parentObjectId){
          if (eventData.isView == true){
            obj.data.isView = true;
          }
          else {
              let disabledViewCount = this.countChildren(obj.children, permissionType);
              if (disabledViewCount == obj.children.length){
                obj.data.isView = false;
              }
          }
          if (eventData.isExport == true){
            obj.data.isExport = true;
          }
          else {
            let disabledViewCount = this.countChildren(obj.children, permissionType);
              if (disabledViewCount == obj.children.length){
                obj.data.isExport = false;
                this.checkUncheckReport(obj.data, permissionType, true);
              }
          }
        }
      })
    }
    else {
      this.profileReportPermissionData.forEach(obj => {
        if (obj.data.objectId == eventData.objectId) {

          obj.children.forEach(child => {

            if (child.data.parentObjectId == eventData.objectId) {
              if (permissionType == 'view') {
                if (obj.data.isView == true){
                  child.data.isView = true;
                  this.checkUncheckReport(child.data, permissionType);
                }
                else{
                  child.data.isView = false;
                  let disabledViewCount = this.countChildren(obj.children, permissionType);
                  if (disabledViewCount == obj.children.length){
                    this.reportPermissionData = [];
                  }
                }

              }
              if (permissionType == 'export') {
                if (obj.data.isExport == true){
                  child.data.isExport = true;
                  this.checkUncheckReport(child.data, permissionType);
                }
                else{
                  child.data.isExport = false;
                }

              }
            }

          })
        }
      });

    }
  }

  countChildren(children: any[], type): number {
    let count  = 0;
    for  (const child of children){
      if (type == 'view'){
        if (child.data.isView === false){
          count++;
        }
      }
      else {
        if (child.data.isExport === false){
          count++;
        }
      }
    }
    return count;
  }

  cancelPermissionModal() {
    this.displayPermission = false;
    this.reportPermissionData = [];
    this.modulePermissionData = [];
  }

  assignReportPermission(): void {
    const result = this.findChangesInReportPermission(this.profileReportPermissionDataVM, this.profileReportPermissionData);
    // console.log(result);
    if (result.length > 0) {
      this.appMainService.isShowSpinner('assignReportPermission');
      this.userProfileService.addProfilePermission(result).subscribe(
        resp => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Report permission updated Successfully...' });
          this.displayPermission = false;
          this.reportPermissionData = [];
          this.appMainService.isHideSpinner('assignReportPermission');
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while updating permissions...' })
          this.appMainService.isHideSpinner('assignReportPermission');
        },
        () => this.appMainService.isHideSpinner('assignReportPermission')
      );
    }
  }

  findChangesInReportPermission(originalObj, modifiedObj){
    const result = [];
    for (const modObj of modifiedObj){
      const origObj = originalObj.find((obj) => obj.data.objectId === modObj.data.objectId);
      if (!origObj) continue;

      if (modObj.data.isExport !== origObj.data.isExport){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isExport,
          permissionId: modObj.data.exportPermissionId
        });
      }

      if (modObj.data.isView !== origObj.data.isView){
        result.push({
          profileID: this.selectedProfile.id,
          objectId: modObj.data.objectId,
          isEnabled: modObj.data.isView,
          permissionId: modObj.data.viewPermissionId
        });
      }

      if (modObj.children && modObj.children.length > 0){
        const childResults = this.findChangesInReportPermission(origObj.children, modObj.children);
        result.push(...childResults);
      }
    }
    return result;
  }

  get name() { return this.profileAddEditForm.get('name'); }
  get newProfile() { return this.profileTransferForm.get('newProfile'); }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
